import {t} from "i18next";

export const translate = (key: string, ns: string): string => {
  const translation = t(key, {ns});
  return translation || `${key}`;
}

export const translateKey = (key: string, args?: {[key: string]: string}): string => {
  const translation = t(key, args);
  return translation || key;
};
